import React from "react";

const IArrowPlay = ({
  color = "#252526",
  width = "20",
  height = "20",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.7392 3.17256C12.625 3.12527 12.4993 3.1129 12.3781 3.13701C12.2569 3.16112 12.1455 3.22063 12.0581 3.30802L5.80808 9.55802C5.75003 9.61606 5.70399 9.68496 5.67258 9.7608C5.64117 9.83663 5.625 9.91791 5.625 9.99999C5.625 10.0821 5.64117 10.1634 5.67258 10.2392C5.70399 10.315 5.75003 10.3839 5.80808 10.442L12.0581 16.692C12.1455 16.7794 12.2569 16.8389 12.3781 16.863C12.4993 16.8871 12.625 16.8747 12.7392 16.8274C12.8534 16.7801 12.951 16.7 13.0197 16.5972C13.0884 16.4944 13.125 16.3736 13.125 16.25V3.74999C13.125 3.62638 13.0883 3.50554 13.0197 3.40276C12.951 3.29998 12.8534 3.21987 12.7392 3.17256V3.17256Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowPlay;
